const omocodeReverseMap = {
  L: 0,
  M: 1,
  N: 2,
  P: 3,
  Q: 4,
  R: 5,
  S: 6,
  T: 7,
  U: 8,
  V: 9,
};

const numberIndexes = [6, 7, 9, 10, 12, 13, 14];

/**
 * In caso di omocodice, i numeri vengono rimappati in lettere secondo uno schema specifico.
 * Questa funzione rimappa tutte le lettere nel numero originale così da poter applicare tutti
 * gli altri check senza eccezioni.
 */
export function remapOmocodeDigit(fiscalCode: string) {
  const updated = fiscalCode.split('').map((char, index) => {
    if (numberIndexes.includes(index)) {
      return (
        omocodeReverseMap[char as keyof typeof omocodeReverseMap]?.toString() ??
        char
      );
    }

    return char;
  });

  return updated.join('');
}
